import { useState } from 'react'
import { motion } from 'framer-motion'
import { MessageSquare, Plus, Trash2, Edit2, Save } from 'lucide-react'

const QuickRepliesSection = () => {
  const [replies, setReplies] = useState([
    { id: 1, title: 'Përshëndetje', text: 'Përshëndetje! Faleminderit që na kontaktuat. Si mund t\'ju ndihmojmë sot?' },
    { id: 2, title: 'Çmimi', text: 'Çmimet tona fillojnë nga €500 për projekte të vogla. Për një ofertë të personalizuar, na tregoni më shumë rreth projektit tuaj.' },
    { id: 3, title: 'Timeline', text: 'Zakonisht një projekt standard merr 2-4 javë. Varet nga kompleksiteti i projektit.' },
    { id: 4, title: 'Portfolio', text: 'Mund të shihni disa nga punët tona këtu: www.contenta.marketing/portfolio' },
    { id: 5, title: 'Takimi', text: 'Do të donim shumë të organizonim një takim! A ju përshtat nesër në orën 14:00?' },
  ])
  const [newReply, setNewReply] = useState({ title: '', text: '' })
  const [editingId, setEditingId] = useState(null)

  const handleAdd = () => {
    if (newReply.title && newReply.text) {
      setReplies([...replies, { ...newReply, id: Date.now() }])
      setNewReply({ title: '', text: '' })
    }
  }

  const handleDelete = (id) => {
    setReplies(replies.filter(r => r.id !== id))
  }

  const handleEdit = (id) => {
    setEditingId(id)
  }

  const handleSave = () => {
    setEditingId(null)
  }

  const handleUpdate = (id, field, value) => {
    setReplies(replies.map(r => r.id === id ? { ...r, [field]: value } : r))
  }

  const handleCopy = (text) => {
    navigator.clipboard.writeText(text)
    alert('Kopjuar në clipboard!')
  }

  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-3xl font-display font-bold text-gradient-gold mb-2">
          Përgjigje të Shpejta
        </h2>
        <p className="text-beige-300">Menaxho template për përgjigje të zakonshme</p>
      </div>

      {/* Add New Reply */}
      <div className="bg-bronze-900/30 backdrop-blur-sm border border-gold-500/20 rounded-2xl p-6">
        <h3 className="text-lg font-display font-bold text-gold-400 mb-4 flex items-center">
          <Plus className="w-5 h-5 mr-2" />
          Shto Përgjigje të Re
        </h3>
        <div className="space-y-4">
          <input
            type="text"
            placeholder="Titulli (p.sh. Përshëndetje, Çmimi, etj.)"
            value={newReply.title}
            onChange={(e) => setNewReply({ ...newReply, title: e.target.value })}
            className="w-full px-4 py-3 bg-dark/50 border border-gold-500/30 rounded-xl text-cream placeholder-beige-400 focus:border-gold-400 focus:ring-2 focus:ring-gold-500/20 transition-all outline-none"
          />
          <textarea
            placeholder="Teksti i përgjigjes..."
            value={newReply.text}
            onChange={(e) => setNewReply({ ...newReply, text: e.target.value })}
            rows={3}
            className="w-full px-4 py-3 bg-dark/50 border border-gold-500/30 rounded-xl text-cream placeholder-beige-400 focus:border-gold-400 focus:ring-2 focus:ring-gold-500/20 transition-all outline-none"
          />
          <button onClick={handleAdd} className="btn-primary">
            <Plus className="w-4 h-4 mr-2" />
            Shto Përgjigje
          </button>
        </div>
      </div>

      {/* Replies List */}
      <div className="grid md:grid-cols-2 gap-4">
        {replies.map((reply) => (
          <motion.div
            key={reply.id}
            initial={{ opacity: 0, scale: 0.95 }}
            animate={{ opacity: 1, scale: 1 }}
            className="bg-bronze-900/30 backdrop-blur-sm border border-gold-500/20 rounded-2xl p-6 hover:border-gold-500/40 transition-all"
          >
            {editingId === reply.id ? (
              <div className="space-y-3">
                <input
                  type="text"
                  value={reply.title}
                  onChange={(e) => handleUpdate(reply.id, 'title', e.target.value)}
                  className="w-full px-3 py-2 bg-dark/50 border border-gold-500/30 rounded-lg text-cream"
                />
                <textarea
                  value={reply.text}
                  onChange={(e) => handleUpdate(reply.id, 'text', e.target.value)}
                  rows={4}
                  className="w-full px-3 py-2 bg-dark/50 border border-gold-500/30 rounded-lg text-cream"
                />
                <button onClick={handleSave} className="btn-primary text-sm">
                  <Save className="w-4 h-4 mr-1" />
                  Ruaj
                </button>
              </div>
            ) : (
              <>
                <div className="flex items-start justify-between mb-3">
                  <h4 className="text-lg font-display font-bold text-gold-400">
                    {reply.title}
                  </h4>
                  <div className="flex space-x-2">
                    <button
                      onClick={() => handleEdit(reply.id)}
                      className="p-2 hover:bg-gold-500/20 rounded-lg transition-all"
                    >
                      <Edit2 className="w-4 h-4 text-beige-300" />
                    </button>
                    <button
                      onClick={() => handleDelete(reply.id)}
                      className="p-2 hover:bg-red-500/20 rounded-lg transition-all"
                    >
                      <Trash2 className="w-4 h-4 text-red-400" />
                    </button>
                  </div>
                </div>
                <p className="text-beige-200 text-sm leading-relaxed mb-4">
                  {reply.text}
                </p>
                <button
                  onClick={() => handleCopy(reply.text)}
                  className="btn-secondary text-sm w-full justify-center"
                >
                  <MessageSquare className="w-4 h-4 mr-2" />
                  Kopjo Tekstin
                </button>
              </>
            )}
          </motion.div>
        ))}
      </div>
    </div>
  )
}

export default QuickRepliesSection
